import {useCallback, useContext, useEffect, useRef} from "react";
import {Context} from "@COMPONENTS/provider/ScrollRestoreProvider";
import {useRouter} from "next/router";

const debounce = (callback: () => void, timeout = 100) => {
	let timer;
	return () => {
		clearTimeout(timer);
		timer = setTimeout(() => {
			callback();
		}, timeout);
	};
};

const useScrollRestoration = () => {
	// const
	const router = useRouter();
	const scrollRestoreContext = useContext(Context);
	const restoreScroll = useRef<number>();

	const event = useCallback(
		debounce(() => scrollRestoreContext.setScrollData()),
		[],
	);

	useEffect(() => {
		restoreScroll.current = scrollRestoreContext.getScrollData();
		window.addEventListener("scroll", event);
		return () => {
			window.removeEventListener("scroll", event);
		};
	}, [router]);

	const setRestoreData = useCallback((data: any) => {
		scrollRestoreContext.setRestoreData(data);
	}, []);

	const getRestoreData = useCallback(() => scrollRestoreContext.getRestoreData(), []);

	const scrollUpdate = useCallback(() => {
		window.scrollTo(0, Number(restoreScroll.current));
	}, []);

	return {setRestoreData, getRestoreData, scrollUpdate};
};

const scrollRestore = () => {
	const scrollRestoreContext = useContext(Context);

	const setRestoreData = useCallback((data: any) => {
		scrollRestoreContext.setRestoreData(data);
	}, []);

	const getRestoreData = useCallback(() => scrollRestoreContext.getRestoreData(), []);

	return {setRestoreData, getRestoreData};
};

export {scrollRestore};
export default useScrollRestoration;
